import { createNav, bindNav } from "./components/Nav.js";
import { createFooter } from "./sections/Footer.js";
import { createContactSection } from "./sections/Contact.js";
import { createInsightsHeroSection } from "./sections/insights/InsightsHero.js";
import { createInsightsFeedSection } from "./sections/insights/InsightsFeed.js";
import { insightsPage, insightsRoute } from "../config/insightsContent.js";

export function mountInsightsPage(root) {
  const canvasLayer = document.createElement("div");
  canvasLayer.className = "canvas-layer";
  canvasLayer.innerHTML = `<canvas id="canvas" aria-hidden="true"></canvas>`;

  const contentLayer = document.createElement("div");
  contentLayer.className = "content-layer content-layer--insights";

  const nav = createNav();

  contentLayer.append(
    nav,
    createInsightsHeroSection(),
    createInsightsFeedSection(),
    createContactSection(),
    createFooter()
  );

  root.append(canvasLayer, contentLayer);

  const updateNavActive = bindNav(nav, {
    page: "insights",
    sectionMap: {
      hero: insightsRoute("hero"),
      library: insightsRoute("library"),
      contact: insightsRoute("contact"),
    },
  });

  return {
    canvas: canvasLayer.querySelector("#canvas"),
    updateNavActive,
    documentTitle: insightsPage.documentTitle,
    sections: {
      hero: contentLayer.querySelector("#hero"),
      library: contentLayer.querySelector("#library"),
      contact: contentLayer.querySelector("#contact"),
    },
  };
}
